import React from 'react';

import { LoggedOutRouter } from 'borrower/routes/LoggedOutRouter';
import { BorrowerRouter } from 'borrower/routes/Router';
import { CapitalProviderRouter } from 'capitalProvider/routes/Router';
import {
  getDecodedTokenOrThrow,
  Logout,
  useUserAuthUnsafe,
  useUserAuthOrThrow,
} from '~/contexts/UserAuthProvider';
import { ValleyBankRouter } from '~/valleyBank/routes/Router';

// Fragments
const LoggedInRouter = () => {
  const { user } = useUserAuthOrThrow();
  const decodedToken = getDecodedTokenOrThrow();

  if (decodedToken.userType === 'BORROWER') {
    return <BorrowerRouter />;
  }

  if (decodedToken.userType === 'CAPITAL_PROVIDER') {
    if (user.organization.slug === 'valleyBank') {
      return <ValleyBankRouter />;
    }
    return <CapitalProviderRouter />;
  }

  // Log all other users out (including SUPER_USER)
  return <Logout />;
};

// Exports
export const Router = () => {
  const { status } = useUserAuthUnsafe();

  if (status === 'loading') return <></>;
  if (status === 'logged-in') return <LoggedInRouter />;
  if (status === 'logged-out') return <LoggedOutRouter />;
  if (status === 'error') {
    throw new Error('Could not find correct router');
  }

  // When in doubt, log user out
  return <Logout />;
};
